import { MOVIE_POSTER_BASE_URL } from "./config";
import { appState } from "./state";
import type { Movie, Video } from "./types";

export const validateAndConvertToLowerCase = (queryString: string) => {
  if (queryString.trim().length === 0) return;
  if (queryString === "") return;

  return queryString.trim().toLowerCase();
};

export const extractYearOfReleaseFromDate = (date: string) => {
  if (date.length <= 0) return "Not Available";
  const yearExtracted = date.trim().split("-")[0];
  if (!yearExtracted || yearExtracted.length > 4) return;
  return yearExtracted;
};

export const constructPosterUrl = (
  imgPath: string,
  original: boolean = false,
) => {
  if (!imgPath || imgPath.length <= 0 || typeof imgPath !== "string")
    return undefined;
  return `${MOVIE_POSTER_BASE_URL}/${original ? "w500" : "w500"}/${imgPath}`;
};

export const hasYouTubeVideo = (video: Video) => {
  if (!video) return false;
  if (video.site.toLowerCase() !== "youtube" || !video.key) return false;

  return true;
};

export const constructYoutubeIframeUrl = (video: Video) => {
  if (!hasYouTubeVideo(video)) return "";

  return `https://www.youtube.com/embed/${encodeURIComponent(
    video.key,
  )}?rel=0&modestbranding=1&playsinline=1`;
};

export const getMovieGenres = (movie: Movie) => {
  const allGenresMap = appState.getGenres();
  const genres = movie.genre_ids.map((genre: number) => {
    if (!allGenresMap.has(genre)) return "";
    return allGenresMap.get(genre)!;
  });

  return genres;
};

export const debounce = <T extends (...args: any[]) => void>(
  fn: T,
  delay = 300,
) => {
  let timer: ReturnType<typeof setTimeout> | null = null;

  return (...args: Parameters<T>) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};
